import React from "react";
import {cn} from "@/lib/utils";

interface IProps extends React.HTMLAttributes<HTMLDivElement>{
    quantity: number;
    activeIndex: number;
    onSelectNewSlide: (index: number) => void;
}

export const CompactPagination = ({quantity, className, activeIndex, onSelectNewSlide}: IProps) => {
    return (
        <div className={cn('inline-flex rounded-full justify-center gap-[6px] p-[8px] bg-black', className)}>
            {Array.from({length: quantity}, (_, index) => (
                <button onClick={() => onSelectNewSlide(index)} key={index} className={cn('rounded-full w-[8px] h-[8px] bg-white opacity-[25%]', {['opacity-[100%]']: activeIndex === index})}/>
            ))}
        </div>
    )
}
